module.exports = __webpack_public_path__ + "0873388d39a59f4acdf1a1fd5db46be8.MP3";